import { useState, useEffect } from "react";
import { IconButton, Badge, Menu, MenuItem } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { io } from "socket.io-client";

function NotificationMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [violenceNotifications, setViolenceNotifications] = useState([]);
  const [crowdNotifications, setcrowdNotifications] = useState([]);
  const [seatnotification, setseatnotification] = useState([]);
  const [hatnotification, sethatnotification] = useState([]);
  const [jacketnotification, setjacketnotification] = useState([]);
  const [glovenotification, setGloveNotification] = useState([]);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // useEffect(() => {
  //   // Fire Detection Socket
  //   const fireSocket = io(
  //     // "http://192.168.20.24:8012",
  //     "https://visionfiredetectionapi.greymatterz.com",
  //     {
  //       reconnectionAttempts: 2,
  //       reconnectionDelay: 3000,
  //     }
  //   );
  //   fireSocket.on("connect", () => {
  //     console.log("✅ Fire socket connected");
  //   });

  //   const handleFireStatus = (data) => {
  //     // console.log("fire_detected", data);
  //     setNotifications((prev) => [data, ...prev]);
  //   };

  //   fireSocket.on("status", handleFireStatus);

  //   return () => {
  //     fireSocket.off("status", handleFireStatus);
  //     fireSocket.disconnect();
  //   };
  // }, []);

  // useEffect(() => {
  //   // Violence Detection Socket
  //   const violenceSocket = io(
  //     "https://visionfightdetectionapi.greymatterz.com",
  //     {
  //       reconnectionAttempts: 2,
  //       reconnectionDelay: 3000,
  //     }
  //   );

  //   const handleViolence = (data) => {
  //     // console.log("violence_detected", data);
  //     setViolenceNotifications((prev) => [data, ...prev]);
  //   };

  //   violenceSocket.on("violence_detected", handleViolence);

  //   return () => {
  //     violenceSocket.off("violence_detected", handleViolence);
  //     violenceSocket.disconnect();
  //   };
  // }, []);

  // useEffect(() => {
  //   const queuewaitSocket = io(
  //     "https://visionqueuewaitingapi.greymatterz.com",
  //     {
  //       transports: ["polling"],
  //       reconnectionAttempts: 2,
  //       reconnectionDelay: 3000,
  //     }
  //   );
  //   queuewaitSocket.on("connect", () => {
  //     console.log("✅ seat monitioring socket connected");
  //   });

  //   const handleViolence = (data) => {
  //     // console.log("absence_alert", data);
  //     setseatnotification((prev) => [data, ...prev]);
  //   };

  //   queuewaitSocket.on("absence_alert", handleViolence);

  //   return () => {
  //     queuewaitSocket.off("absence_alert", handleViolence);
  //     queuewaitSocket.disconnect();
  //   };
  // });

  // useEffect(() => {
  //   const crowdDetectSocket = io(
  //     "https://visioncrowddetectionapi.greymatterz.com",
  //     {
  //       transports: ["polling"],
  //       reconnectionAttempts: 2,
  //       reconnectionDelay: 3000,
  //     }
  //   );
  //   crowdDetectSocket.on("connect", () => {
  //     console.log("✅ crowd socket connected");
  //   });

  //   const handleCrowd = (data) => {
  //     console.log("crowd_data", data);
  //     setcrowdNotifications((prev) => [data, ...prev]);
  //   };

  //   crowdDetectSocket.on("crowd_data", handleCrowd);

  //   return () => {
  //     crowdDetectSocket.off("crowd_data", handleCrowd);
  //     crowdDetectSocket.disconnect();
  //   };
  // });

  // useEffect(() => {
  //   const jacketDetectSocket = io(
  //     "https://visionhatjacketdetectionapi.greymatterz.com/",
  //     {
  //       transports: ["polling"],
  //       reconnectionAttempts: 2,
  //       reconnectionDelay: 3000,
  //     }
  //   );
  //   jacketDetectSocket.on("connect", () => {
  //     console.log("✅ jacket/hat socket connected");
  //   });

  //   const handleCrowd = (data) => {
  //     console.log("status", data);
  //     setjacketnotification((prev) => [data, ...prev]);
  //   };
  //   const handledata = (data) => {
  //     console.log("status", data);
  //     sethatnotification((prev) => [data, ...prev]);
  //   };
  //   const handleGlove = (data) => {
  //     console.log("glove_alert", data);
  //     setGloveNotification((prev) => [data, ...prev]);
  //   };

  //   jacketDetectSocket.on("jacket_alert", handleCrowd);
  //   jacketDetectSocket.on("hat_alert", handledata);

  //   jacketDetectSocket.on("glove_alert", handleGlove);

  //   return () => {
  //     jacketDetectSocket.off("jacket_alert", handleCrowd);
  //     jacketDetectSocket.off("hat_alert", handledata);
  //     jacketDetectSocket.off("glove_alert", handleGlove);
  //     jacketDetectSocket.disconnect();
  //   };
  // });

  const totalNotifications =
    notifications.length +
    violenceNotifications.length +
    crowdNotifications.length +
    seatnotification.length;

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen}>
        <Badge badgeContent={totalNotifications} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        {totalNotifications === 0 ? (
          <MenuItem>No new notifications</MenuItem>
        ) : (
          <>
            {notifications.map((notif, i) => (
              <MenuItem key={`fire-${i}`}>
                {notif?.message || "Fire alert"} from{" "}
                {notif?.camera_name || "Unknown"} in{" "}
                {notif?.camera_location || "Unknown location"}
              </MenuItem>
            ))}
            {violenceNotifications.map((notif, i) => (
              <MenuItem key={`violence-${i}`}>
                {notif?.message || "Violence detected"} from{" "}
                {notif?.camera_name || "Exit Camera"} in{" "}
                {notif?.camera_location || "Exit"}
              </MenuItem>
            ))}
            {crowdNotifications.map((notif, i) => (
              <MenuItem key={`Crowd-${i}`}>
                {notif?.message || "Crowd detected"} from{" "}
                {notif?.camera_name || "Exit Camera"}
              </MenuItem>
            ))}
            {hatnotification.map((notif, i) => (
              <MenuItem key={`Hat-${i}`}>
                {notif?.message || "Hat detected"} from{" "}
                {notif?.camera_name || "Exit Camera"}
              </MenuItem>
            ))}
            {jacketnotification.map((notif, i) => (
              <MenuItem key={`Jacket-${i}`}>
                {notif?.message || "Jacket detected"} from{" "}
                {notif?.camera_name || "Exit Camera"}
              </MenuItem>
            ))}
            {seatnotification.map((notif, i) => (
              <MenuItem key={`absent-${i}`}>
                {notif?.message || "no message"}
              </MenuItem>
            ))}

            {glovenotification.map((notif, i) => (
              <MenuItem key={`absent-${i}`}>
                {notif?.message || "no message"}
              </MenuItem>
            ))}
          </>
        )}
      </Menu>
    </>
  );
}

export default NotificationMenu;
